const state = {
    data: []
}

const mutations = {
    storePromo (state, payload) {
        state.data = payload
    },
    addPromo (state, payload) {
        state.data.unshift(payload)
    },
    changePromoStatus (state, payload) {
        const promo = state.data.find(item => item.id === payload.id)

        promo.status = payload.status
    },
    deletePromo (state, payload) {
        const promo = state.data.find(item => item.id === payload.id)

        promo.deleted = 1
    }
}

const actions = {}

const getters = {
    getPromos: state => state.data
}

export default {
    state,
    mutations,
    actions,
    getters
}
